import React from "react";

import { useAppInitialization } from "@hooks/use-app-initialization";
import { OnboardingSteps } from "@hz/stealthy-gmc-cloaker-common/constants";

import { Navigate, Route, BrowserRouter as Router , Routes } from "react-router-dom";

import { Box, Center , Spinner } from "@chakra-ui/react";

import { NewStoreFlow } from "@compositions/newStore";
import { NotFound } from "@compositions/notFound";
import { OnboardingFlow } from "@compositions/onboarding";
import { SetPassword } from "@compositions/setPassword";
import { UpgradeSubscriptionPage } from "@compositions/upgradeSubscription";
import { Users } from "@compositions/users";
import { WhitelistIPs } from "@compositions/whitelistIPs";

import { ProtectedRoute } from "@utils/ProtectedRoute";
import { PublicOnlyRoute } from "@utils/PublicOnlyRoute";

// import { Analytics } from "./pages/Analytics";
import { ForgotPassword } from "./pages/ForgotPassword";
import { Login } from "./pages/Login";
import { Settings } from "./pages/Settings";
import { Stores } from "./pages/Stores";

export function App() {
  const { isLoading, accountId, userId, onboardingStep } = useAppInitialization();

  const isAuthenticated = !!accountId && !!userId;
  const isOnboardingResolved = !isAuthenticated || onboardingStep !== null;

  if (isLoading || !isOnboardingResolved) {
    return (
      <Center height="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  const isOnboardingComplete = onboardingStep === OnboardingSteps.COMPLETED;

  console.log(`accountId ${accountId}, userId ${userId}`);

  return (
    <Box
      bg="gray.900"
      minH="100vh"
      color="white"
    >
      <Routes>
        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          {isOnboardingComplete ? (
            <>
              <Route
                path="/"
                element={<Stores />}
              />
              <Route
                path="/stores"
                element={<Stores />}
              />
              <Route
                path="/stores/new"
                element={<NewStoreFlow />}
              />
              {/* <Route
                path="/analytics"
                element={<Analytics />}
              /> */}
              <Route
                path="/users"
                element={<Users />}
              />
              <Route
                path="/settings"
                element={<Settings />}
              />
              <Route
                path="/whitelist"
                element={<WhitelistIPs />}
              />
            </>
          ) : (
            <Route
              path="*"
              element={
                <Navigate
                  to="/onboarding"
                  replace
                />
              }
            />
          )}
        </Route>

        <Route
          path="/onboarding"
          element={<OnboardingFlow />}
        />
        <Route
          path="/upgrade"
          element={<UpgradeSubscriptionPage />}
        />

        {/* Public-only Auth Routes */}
        <Route element={<PublicOnlyRoute />}>
          <Route
            path="/ap/login"
            element={<Login />}
          />
          <Route
            path="/ap/forgot-password"
            element={<ForgotPassword />}
          />
          <Route
            path="/ap/set-password"
            element={<SetPassword />}
          />
        </Route>

        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </Box>
  );
}
